import { INotificationType } from 'libs/domain';

export function isChallengeResponseNotification(type: string): boolean {
  if (!type) {
    return false;
  }
  switch (type) {
    case INotificationType.CHALLENGE_RESPONSE_DENIED:
      return true;
    default:
      break;
  }

  return false;
}
